import React from 'react';
import Downshift from 'downshift';
import { ReactComponent as SearchIcon } from '../../svg/fa/search.svg';
import IntlContext from '@jetshop/intl/context';
// import styled from 'react-emotion';

const StoresDropdown = ({
  stores,
  setSelectedStore,
  selectedStore,
  selectedRegion,
}) => {
  return (
    <>
      <Downshift
        onChange={(selection) => {
          setSelectedStore(selection);
        }}
        itemToString={(store) => (store ? store.name : '')}
      >
        {({
          getInputProps,
          getItemProps,
          isOpen,
          closeMenu,
          inputValue,
          selectedItem,
          getRootProps,
        }) => {
          return (
            <div>
              <IntlContext.Consumer>
                {(t) => (
                  <input
                    placeholder={t('Search')}
                    {...getInputProps({
                      onKeyUp: (e) => {
                        if (inputValue === '') {
                          closeMenu();
                        }
                      },
                    })}
                  />
                )}
              </IntlContext.Consumer>
              <SearchIcon />
              {isOpen && (
                <ul>
                  {isOpen &&
                    stores
                      .filter(
                        (store) =>
                          !inputValue ||
                          store.name
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                      )
                      .map((store, index) => (
                        <React.Fragment key={store.id}>
                          {store && (
                            <li
                              {...getItemProps({
                                key: store.name,
                                index,
                                item: store,
                                style: {
                                  backgroundColor: 'white',
                                },
                              })}
                            >
                              {store.name} - {store.region}
                            </li>
                          )}
                        </React.Fragment>
                      ))}
                </ul>
              )}
            </div>
          );
        }}
      </Downshift>
    </>
  );
};

export default StoresDropdown;
